var map = {
	"./dots-square.svg": 50,
	"./hero-preset-four-ellipse-left.png": 51,
	"./hero-preset-four-ellipse-right.png": 52,
	"./hero-preset-one-ellipse.png": 53,
	"./hero-preset-three-ellipse-bottom-left.png": 54,
	"./hero-preset-three-ellipse-left.png": 55,
	"./hero-preset-three-ellipse-right.png": 56,
	"./hero-preset-three-texture-left-mobile.png": 57,
	"./hero-preset-three-texture-left.png": 58,
	"./hero-preset-three-texture-right-mobile.png": 59,
	"./hero-preset-three-texture-right.png": 60,
	"./hero-preset-two-ellipse-right.png": 61,
	"./outro-ellipse-left.png": 62,
	"./outro-ellipse-right.png": 63,
	"./outro-texture-bottom.png": 64,
	"./secondary-dots.png": 65,
	"./shapes/blob-top-left.svg": 66,
	"./shapes/blob-top-right.svg": 67,
	"./shapes/blobs-top-both.svg": 68,
	"./shapes/clip-paths.svg": 69,
	"./shapes/curve-top-left.svg": 70,
	"./shapes/curves-top-left-right-mobile.svg": 71,
	"./shapes/curves-top-left-right.svg": 72,
	"./shapes/dots-bottom-left-horizontal-desktop.svg": 73,
	"./shapes/dots-bottom-mobile-tall.svg": 74,
	"./shapes/dots-bottom-mobile.svg": 75,
	"./shapes/dots-bottom-right-desktop.svg": 76,
	"./shapes/dots-bottom-right-horizontal-desktop.svg": 77,
	"./shapes/dots-top-right-vertical.svg": 78,
	"./shapes/wave-bottom-desktop-reverse.svg": 79,
	"./shapes/wave-bottom-desktop.svg": 80,
	"./shapes/wave-bottom-mobile.svg": 81,
	"./shapes/wave-bottom-short.svg": 82,
	"./shapes/wave-bottom-tall-mobile.svg": 83,
	"./shapes/wave-top-dots-left.svg": 84,
	"./shapes/wave-top-dots-right.svg": 85,
	"./shapes/wave-top-mobile.svg": 86,
	"./situation-group-placeholder.jpg": 87,
	"./svg-sprite/icon-arrow-left.svg": 88,
	"./svg-sprite/icon-arrow-right.svg": 89,
	"./svg-sprite/icon-arrow.svg": 90,
	"./svg-sprite/icon-dropdown-arrow.svg": 91,
	"./svg-sprite/icon-email.svg": 92,
	"./svg-sprite/icon-in-person.svg": 93,
	"./svg-sprite/icon-linkedin.svg": 94,
	"./svg-sprite/icon-phone.svg": 95,
	"./svg-sprite/icon-pin.svg": 96,
	"./svg-sprite/icon-small-arrow.svg": 97,
	"./svg-sprite/icon-virtual.svg": 98,
	"./team-card-ellipse-1.png": 99,
	"./team-card-ellipse-2.png": 100,
	"./team-card-ellipse-3.png": 101,
	"./team-card-ellipse-4.png": 102,
	"./wave.png": 103,
	"./wave.svg": 104,
	"./white-dots-background.png": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;